<script>
import ContentsWithLinks from "@/components/article/politiken/ContentsWithLinks.vue";
import lang from "@/directives/lang";

import { findWordclass } from "./wordclassMapper";

export default {
  name: "ArticleContentHeader",
  components: {
    ContentsWithLinks
  },
  directives: {
    lang
  },
  props: {
    word: {
      type: Object,
      required: true
    }
  },
  methods: {
    expandWordclass(wordclass) {
      return findWordclass(wordclass);
    }
  }
};
</script>

<template>
  <div class="article-content__header article-header d-flex flex-lg-row justify-content-between">
    <div class="article-header__content">
      <div class="d-inline-block">
        <span v-if="word.mark">* </span>
        <h5 v-lang:source class="article-header__word">{{ word.lemmaOne }}</h5>
        <sup v-if="word.hnr" class="pol-header-sup"> {{ word.hnr }}</sup>
        <sup v-if="word.trademark">{{ word.trademark }}</sup>

        <template v-if="word.lemmaTwoOne">
          <span class="article-header__element article-header__element--chained">el.</span>
          <h5 class="article-header__word article-header__element article-header__element--chained">
            {{ word.lemmaTwoOne }}
          </h5>
        </template>

        <span
          v-if="word.wordclass"
          class="article-header__element article-header__element--light article-header__element--italic"
        >
          {{ expandWordclass(word.wordclass) }}
        </span>
        <span
          v-if="word.flexion"
          class="article-header__element article-header__element--light article-header__element--chained article-header__element--italic"
          v-html="`(${word.flexion})`"
        ></span>

        <span
          v-if="word.lemmaTwo"
          class="article-header__element article-header__element--prominent article-header__element--light"
          v-html="word.lemmaTwo"
        ></span>
        <span
          v-if="word.wordclassTwo"
          class="article-header__element article-header__element--light article-header__element--italic"
          >{{ expandWordclass(word.wordclassTwo) }}</span
        >
        <span
          v-if="word.flexionExtra"
          class="article-header__element article-header__element--light article-header__element--chained article-header__element--italic"
          v-html="word.flexionExtra"
        ></span>
        <span
          v-if="word.flexionTwo"
          class="article-header__element article-header__element--light article-header__element--chained article-header__element--italic"
          v-html="`(${word.flexionTwo})`"
        ></span>

        <template v-if="word.abbreviation">
          <span class="article-header__element article-header__element--light">fork.</span>
          <span
            class="article-header__element article-header__element--prominent article-header__element--chained article-header__element--light"
            >{{ word.abbreviation }}</span
          >
        </template>

        <div v-if="word.reference.length > 1" class="d-inline article-header__element">
          <ContentsWithLinks
            v-for="(reference, referenceIndex) in word.reference"
            :key="referenceIndex"
            :content="reference"
            text-class="article-header__element article-header__element--light article-header__element--unchained article-header__element--italic"
            link-class="article-content__text article-content__text--link"
          ></ContentsWithLinks>
        </div>
      </div>
    </div>
  </div>
</template>
